import React from "react"
import RehypeReact from "rehype-react"

const GifPlayer =
  typeof window !== "undefined" ? require("react-gif-player") : undefined

const components = {}

if (GifPlayer) {
  components["gif-player"] = GifPlayer
}

export default new RehypeReact({
  createElement: React.createElement,
  components,
}).Compiler
